import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { useTheme } from '../context/ThemeContext';
import { useAuth } from '../context/AuthContext';
import { spacing, fontSize, fontWeight, borderRadius } from '../utils/theme';
import type { ColorTheme } from '../utils/theme';
import ContentContainer from './ContentContainer';

/** SuspendedBanner - full-screen notice shown when an owner's account is suspended. */
export default function SuspendedBanner() {
  const { colors } = useTheme();
  const { logout } = useAuth();
  const styles = useStyles(colors);

  return (
    <ContentContainer>
      <View style={styles.container}>
        <View style={styles.iconWrap}>
          <Ionicons name="lock-closed" size={48} color={colors.danger} />
        </View>
        <Text style={styles.title}>Account Suspended</Text>
        <Text style={styles.message}>
          Your account has been suspended by an administrator. You can still update your password and security settings.
        </Text>
        <Text style={styles.contact}>
          If you believe this is an error, please contact support at support@rinsepay.app
        </Text>
        <TouchableOpacity style={styles.logoutBtn} onPress={logout}>
          <Ionicons name="log-out-outline" size={18} color={colors.white} />
          <Text style={styles.logoutText}>Log Out</Text>
        </TouchableOpacity>
      </View>
    </ContentContainer>
  );
}

const createStyles = (c: ColorTheme) => StyleSheet.create({
  container: { flex: 1, justifyContent: 'center', alignItems: 'center', padding: spacing.xl },
  iconWrap: { marginBottom: spacing.lg, backgroundColor: c.dangerLight, borderRadius: 40, width: 80, height: 80, justifyContent: 'center', alignItems: 'center' },
  title: { fontSize: fontSize.xxl || 24, fontWeight: fontWeight.bold, color: c.text, marginBottom: spacing.sm },
  message: { fontSize: fontSize.md, color: c.textSecondary, textAlign: 'center', lineHeight: 22, marginBottom: spacing.md, maxWidth: 400 },
  contact: { fontSize: fontSize.sm, color: c.textLight, textAlign: 'center', marginBottom: spacing.xl, maxWidth: 400 },
  logoutBtn: { flexDirection: 'row', alignItems: 'center', gap: 6, backgroundColor: c.danger, borderRadius: borderRadius.sm, paddingHorizontal: spacing.lg, paddingVertical: spacing.sm },
  logoutText: { fontSize: fontSize.sm, color: c.white, fontWeight: fontWeight.semibold },
});

const useStyles = (c: ColorTheme) => React.useMemo(() => createStyles(c), [c]);
